<template>
  <!--tabbar-->
  <div style="overflow-y: scroll;height: 100vh;">
    <van-pull-refresh
      v-model="isLoading"
      @refresh="onRefresh"
      :disabled="loading"
    >
      <van-list
        v-if="!nodata"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多数据了"
        :offset="20"
        @load="onLoad"
      >
        <van-cell-group
          v-for="(item, index) in list"
          :key="index">
          <van-cell :border="false">
            <template #title>
              <span class="item-time">{{item.creat_time}}</span>
            </template>
            <template #default>
              <p class="item-type">
                <span class="dot"></span> {{item.status | statusToText}}
              </p>
            </template>
          </van-cell>
          <van-cell :border="false" class="item-no">
            <template #title>
              <div class="custom-default">
                <van-row>
                  <van-col span="24">运输单号：{{item.num}}</van-col>
                  <van-col span="13">计划发货总数：{{item.totalAmount}}{{item.amountUnit}}</van-col>
                  <van-col span="11" class="right">交易类型：{{item.quoteType | quoteTypeToText}}</van-col>
                  <van-col span="24">总运费：{{item.total_tran_cost_out}}元</van-col>
                </van-row>
              </div>
            </template>
          </van-cell>
          <van-cell :border="false" class="item-ft" title="">
            <template #label>
              <div class="btn-box-1">
                <van-button round plain type="info" size="small"  :to="{ name: 'Invoice',params:{bId : item.id} }">对应发货单</van-button>
              </div>
            </template>
          </van-cell>
        </van-cell-group>
      </van-list>
      <van-empty v-else
        class="custom-image"
        :image="require('../../styles/img/nodata.png')"
      />
    </van-pull-refresh>
  </div>
</template>

<script>
export default {
  name: "TransportOrderList",
  props: ['channel'],
  data() {
    return {
      list: [],
      nodata: false, // 是否有数据
      loading: false, // 是否上拉加载
      finished: false, // 上拉加载是否结束即加载全部数据
      isLoading: false, // 是否下拉刷新
      currentPage: 0,
      showCount: 10, //每页个数
      status: '',
      activeId: '',
      tId:''
    }
  },
  created () {
    this.tId = this.$route.params.id
    // console.log(this.tId)
    this.bus.$off()
    // 切换标签的对应id
    this.bus.$on('transportOrderTabsId', (data) => {
      const { transportOrderTabsId } = data
      this.activeId = transportOrderTabsId
      if (transportOrderTabsId !== this.activeId) {
        return
      }
      this.nodata = false;
      this.finished = false;
      this.loading = true;
      this.currentPage = 1;
      this.list = [];
      this.getData();
    })
    // 监听搜索框
    this.bus.$on('svalue', (data) => {
      const { svalue } = data
      this.svalue = svalue
      // console.log(this.svalue)
      this.nodata = false;
      this.finished = false;
      this.loading = true;
      this.currentPage = 1;
      this.list = [];
      this.getData();
    })
  },
  methods: {
    // 请求数据
    getData() {
      let status = this.activeId=== '0'?'':this.activeId;
      let tId = this.tId;
      let svalue = this.svalue||'';
      this.loading = true;
      this.isLoading = false;
      this.finished = false;
      let data = {
        num: svalue,        //发货单号
        tId: tId=='0'?'':tId,     //运输单id 查询运输单对应的发货单
        status: status,  // 发货单状态 0:未开始 1:已接单  2:运输中 3:已到达 4:已签收  5:已取消
        currentPage: this.currentPage, // 当前页数
        showCount: this.showCount    //显示个数
      };
      // if(this.isLoading === true){
      //   this.loading = false
      // }
      this.$api.apis.bidList(data).then(res => {
        this.loading = false
        if(res.flag !== '200') {
          this.nodata = true
          return false
        }
        this.totalResult = res.rsObj.page.totalResult
        res.rsObj.page.totalResult > 0 ? (this.nodata = false) : (this.nodata = true)
        this.list = this.list.concat(res.rsObj.bidOrderList)
        if (this.list.length >= this.totalResult && this.list.length !== 0) {
        	this.finished = true;
        }
        // if(res&&res.rsObj&&res.rsObj.bidOrderList&&res.rsObj.bidOrderList.length>0){
        //   this.currentPage += 1;
        //   this.list = this.list.concat(res.rsObj.bidOrderList)
        //   // 加载状态结束
        //   this.loading = false
        //   if (res.rsObj.bidOrderList.length === 0||res.rsObj.bidOrderList.length<this.showCount) {
        //     this.finished = true
        //   }
        // }else{
        //   this.finished = true
        //   this.loading = false
        //   this.nodata = false
        // }
        // this.isLoading = false
      });
    },
    // 下拉刷新
    onRefresh () {
      this.currentPage = 1;
      this.nodata = false;
      this.finished = false;
      this.list = [];
      this.getData()
      // this.$toast.success('刷新成功')
    },
    onLoad() {
      this.currentPage++
      this.getData();
    },
  },
  filters: {
    statusToText : (value) => {
      let result = "";
      switch(parseInt(value)){
        case 1:
          result = '未发布';
          break;
        case 3:
          result = '待确认';
          break;
        case 5:
          result = '已确认';
          break;
        case 10:
          result = '已完成';
          break;
        default :
          result = ''
      }
      return result;
    },
    quoteTypeToText : (value) => {
      let result = "";
      switch(parseInt(value)){
        case 1 :
          result = '一口价';
          break;
        case 2 :
          result = '竞价';
          break;
        case 3 :
          result = '委托运输';
          break;
        default :
          result = ''
      }
      return result;
    }
  },
  watch: {}
};
</script>
<style lang="less">
  @import '../../styles/order.less';
</style>



// WEBPACK FOOTER //
// src/components/List/TransportOrderList.vue